import { Link } from "react-router-dom";

interface ArticleCardProps {
  slug: string;
  title: string;
  imageUrl: string;
  tag?: string;
  date: string;
  views: string;
  isHot?: boolean;
  isFirst?: boolean;
}

export default function ArticleCard({
  slug,
  title,
  imageUrl,
  tag,
  date,
  views,
  isHot,
  isFirst,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block flex-shrink-0 w-[280px] md:w-[300px] bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all duration-300 cursor-pointer"
    >
      <div className="relative">
        {isFirst && tag && (
          <span className="absolute top-3 left-3 z-10 px-3 py-1 rounded-full bg-foreground-950 text-background-50 text-xs font-medium">
            {tag}
          </span>
        )}
        {isHot && !tag && (
          <span className="absolute top-3 left-3 z-10 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
            热门
          </span>
        )}
        <div className="w-full h-[180px] overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 今日大瓜`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-950 leading-snug line-clamp-2 mb-3 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{date}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-xs"></i>
            {views}
          </span>
        </div>
      </div>
    </Link>
  );
}